interface CurriculumMooshimProps {
  techniques: string[];
  hasDemo?: (aliases: string[]) => boolean;
  onWatchDemo?: (aliases: string[]) => void;
}

const MOOSHIM_DEMO_ALIASES = ["mooshim"];

export default function CurriculumMooshim({
  techniques,
  hasDemo,
  onWatchDemo,
}: CurriculumMooshimProps) {
  if (techniques.length === 0) {
    return (
      <p className="text-center text-sm text-gray-600">
        No Mooshim requirements for this belt.
      </p>
    );
  }

  return (
    <div className="space-y-4 text-left">
      {hasDemo?.(MOOSHIM_DEMO_ALIASES) && (
        <div>
          <button
            type="button"
            className="inline-flex items-center text-sm font-medium text-taekwondo-blue hover:underline"
            onClick={() => onWatchDemo?.(MOOSHIM_DEMO_ALIASES)}
          >
            Watch Demonstration Video
          </button>
        </div>
      )}
      <div className="rounded-lg bg-gray-50 p-4 md:p-5">
        <ol className="list-none space-y-3">
          {techniques.map((name, index) => (
            <li key={`${name}-${index}`} className="flex gap-3">
              <span className="min-w-[2rem] shrink-0 font-semibold tabular-nums text-taekwondo-red">
                {index + 1}.
              </span>
              <span className="text-gray-700">{name}</span>
            </li>
          ))}
        </ol>
      </div>
    </div>
  );
}
